import React from "react";

import imagen from "../../assets/image/stella/installsmartv2.png";
import background from "../../assets/image/stella/precios.png";
import fondobanner from "../../assets/image/stella/reventa_fondo.jpg";
import {HashLink} from "react-router-hash-link";

function Section3() {

    return (
        <>
            <section className="relative py-20 md:py-42">
                <div
                    className="absolute inset-0 bg-contain bg-repeat-y opacity-10 z-0"
                    style={{
                        backgroundImage: ` url(${background})`,
                    }}></div>
                <div className="relative container px-5 grid md:grid-cols-[58%_1fr] gap-10 z-10">
                    <div
                        className="max-md:text-center pt-5 md:pt-10 intersect:animate-in slide-in-from-left intersect-once duration-1250">
                        <h3 className="text-2xl md:text-[37px] uppercase font-semibold leading-tight">Stella TV para
                            Fire TV Stick</h3>
                        <div className="mt-5 flex items-center gap-[5px]">
                            <div className="bg-[#F5A966] w-1 h-1 rounded-full"></div>
                            <div className="bg-[#F5A966] w-1 h-1 rounded-full"></div>
                            <div className="bg-[#F5A966] w-1 h-1 rounded-full"></div>
                            <div className="bg-[#F5A966] w-[100px] h-1 rounded-xs"></div>
                        </div>
                        <div className="mt-2 leading-relaxed text-white">Disfrute del mejor entretenimiento multimedia
                            al <span
                                className="text-[#ff6600]">MEJOR PRECIO.  </span>
                            En un solo plan puede disfrutar de 1000 canales y una amplia biblioteca de películas,
                            series, anime y contenido para adultos +18. Contrate ahora y cancele cuando quiera!
                            <span
                                className="text-[#ff6600]">Comprar Stella TV Apk </span>
                        </div>
                        <div className="mt-12 flex flex-col gap-6">
                            <HashLink to='/#inicio' className="btn-primary no-underline text-white inline-flex gap-1 px-8 py-3 justify-center md:max-w-max">
                                <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24"
                                     fill="currentColor" className="text-2xl">
                                    <path
                                        d="m12 12.9-2.13 2.09c-.56.56-.87 1.29-.87 2.07C9 18.68 10.35 20 12 20s3-1.32 3-2.94c0-.78-.31-1.52-.87-2.07z"></path>
                                    <path
                                        d="m16 6-.44.55C14.38 8.02 12 7.19 12 5.3V2S4 6 4 13c0 2.92 1.56 5.47 3.89 6.86-.56-.79-.89-1.76-.89-2.8 0-1.32.52-2.56 1.47-3.5L12 10.1l3.53 3.47c.95.93 1.47 2.17 1.47 3.5 0 1.02-.31 1.96-.85 2.75 1.89-1.15 3.29-3.06 3.71-5.3.66-3.55-1.07-6.9-3.86-8.52"></path>
                                </svg>
                                COMPRAR Stella Tv</HashLink>

                        </div>
                    </div>
                    <img alt="magis tv ofertas descuentos promociones" loading="lazy" width="500" height="400"
                         decoding="async" data-nimg="1"
                         className="mt-20 w-full md:w-[70%] max-w-[500px] mx-auto h-auto rounded-[10px] intersect:animate-in slide-in-from-right intersect-once duration-1250"
                         src={imagen}/></div>
            </section>
        </>
    );
}

export default Section3;
